import BaseNavBar from "./BaseNavBar";
import { getCountry } from "./CountryUtil";

function Support(props) {
    return (
        <div className="main-layout contineer_page">
            <header>
                <BaseNavBar {...props} active='support' />
            </header>

            <div className="backgro_mh">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="heding">
                                <h2>Support</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="about" className="about">
                <div className="container">
                    <div className="row display_boxflex">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div className="about-box">
                                <h2>Support</h2>
                                <p>
                                Thank you for using {getCountry(props.match.params.siteid).appName} . If you have any suggestions , complains or any other requirements, Contact us through email mrppa.dev@gmail.com or mobile +94 715204962
                                </p>
                                <p>
                                All Content providers are listed in app under support segment
                                </p>
                                <img src="/images/scr_1.jpg" alt=""/>
                                
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Support;
